import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import i from '../imports';
import c from '../components';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

const toursToDisplay = 12;

class Tour extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cityValue: this.propsToCityFilter(props),
            tourTypeValue: this.propsToTourFilter(props),
            toursToDisplay
        };
    }

    handleCityChange = (event, index, value) => this.setState({
        cityValue: value,
        toursToDisplay
    });
    handleTourTypeChange = (event, index, value) => this.setState({
        tourTypeValue: value,
        toursToDisplay
    });

    readTours = () => {
        let filteredTours = Session.model.tourPages;

        if (this.state.cityValue && this.state.cityValue != EMPTY_FILTER_VALUE) {
            filteredTours = filteredTours.filter(f => f.relation_destinations !== undefined && f.relation_destinations.map(m => m.destinationpages).indexOf(this.state.cityValue) > -1);
        }

        if (this.state.tourTypeValue && this.state.tourTypeValue != EMPTY_FILTER_VALUE) {
            filteredTours = filteredTours.filter(f => f.type === this.state.tourTypeValue);
        }

        let displayedTours = filteredTours.slice(0, this.state.toursToDisplay);

        return {
            displayedTours,
            filteredTours,
            hasMore: displayedTours.length < filteredTours.length
        };
    }



    readToursByType = (tourType) => {
        let filteredTours = Session.model.tourPages;

        if (this.state.cityValue && this.state.cityValue != EMPTY_FILTER_VALUE) {
            let test = filteredTours[0].relation_destinations.map(m => m.destinationpages);
            filteredTours = filteredTours.filter(f => f.relation_destinations !== undefined && f.relation_destinations.map(m => m.destinationpages).indexOf(this.state.cityValue) > -1);
        }

        filteredTours = filteredTours.filter(f => f.type === tourType);
        

        let displayedTours = filteredTours.slice(0, this.state.toursToDisplay);

        return {
            displayedTours,
            filteredTours,
            hasMore: displayedTours.length < filteredTours.length
        };
    }

    showMore = () => {
        this.setState({ toursToDisplay: this.state.toursToDisplay + 6 })
    }

    readDestinations = (excludeDestinations) => {
        return Session.model.destinationPages.filter(dest => excludeDestinations.indexOf(dest.name) === -1);
    }

    propsToTourFilter = (props) => {
        return props.type || EMPTY_FILTER_VALUE;
    }

    propsToCityFilter = (props) => {
        return props.city ? props.city : EMPTY_FILTER_VALUE;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            cityValue: this.propsToCityFilter(nextProps),
            tourTypeValue: this.propsToTourFilter(nextProps),
        });
    }

    renderToursBlock(toursData, tourType){

        let currentTourTypeName = Session.model.data.tourtypes.filter(f => f.name === tourType)[0].translations[0].name
        return (
            <div>
                <i.Row>
                    <i.Col>
                        <h2>{currentTourTypeName}</h2>
                        {toursData.displayedTours.length > 0 ?
                            <c.CardsList items={i.Utils.sortByIndex(toursData.displayedTours)} urlBuilder={i.Utils.createTourUrl} />
                            : <div style={{
                                color: "#FF5563", fontSize: 18, paddingTop: 20, fontWeight: "bold"
                            }}>{Session.model.common.words.no_result}</div>
                        }
                    </i.Col>
                </i.Row>
                {/* <i.Row style={{ paddingBottom: 20 }}>
                    <i.Col>
                        {
                            (this.state.tourTypeValue && this.state.tourTypeValue !== EMPTY_FILTER_VALUE)
                            ?
                            toursData.hasMore ? <h2 style={{ color: "#FF5563", cursor: "pointer" }} onClick={this.showMore}>{Session.model.common.more}</h2> : null
                            :
                            <h2><i.NavLink style={{ color: "#FF5563", textDecoration: "none" }} to={`${i.Utils.locUrl("tours")}\\${tourType}`}>{Session.model.common.words.find_more}</i.NavLink></h2>
                        }
                    </i.Col>
                </i.Row> */}
            </div>
        );
    }

    render() {
        let cityFilterValues = [{ id: EMPTY_FILTER_VALUE, text: Session.model.tours.all_cities }];

        cityFilterValues = cityFilterValues.concat(Session.model.destinationPages.map(d => {
            return {
                id: d.name,
                text: d.translations[0] ? d.translations[0].title : ""
            };
        }));


        let tourTypes = [];
        let tourBlocks = [];

        if (this.state.tourTypeValue && this.state.tourTypeValue !== EMPTY_FILTER_VALUE){
            let tourBlock = this.readTours();
            tourBlocks.push(this.renderToursBlock(tourBlock, this.state.tourTypeValue));

        } else {
            tourTypes = Session.model.data.tourtypes.map(m => m.name);
            tourTypes.map(m => {  
                let tourBlock = this.readToursByType(m);
                tourBlocks.push(this.renderToursBlock(tourBlock, m));
            })
        }
        let toursData = this.readTours();

        let existsDestinations = toursData.filteredTours.map(d => d.destination);

        let destinations = Session.model.destinationPages;
        destinations = i.Utils.sortByIndex(destinations).slice(0, 3);

        let currentTourTypeName;
        let shortPageDescription;

        if(this.state.tourTypeValue && this.state.tourTypeValue != EMPTY_FILTER_VALUE) {
            let curTourType = Session.model.data.tourtypes.filter(f => f.name == this.state.tourTypeValue)[0].translations[0];

            currentTourTypeName = curTourType.name;
            shortPageDescription = curTourType.short_description;
        } else {
            currentTourTypeName = "";
            shortPageDescription = Session.model.tours.text;
        }

        return (
            <BasePage data={Session.model.tours}>
                <BreadCrumbs fullpath={window.location.pathname} name={currentTourTypeName} />    
                <i.Container>
                    {
                        tourBlocks
                    }
                    <i.Row style={{ paddingBottom: 20 }}>
                        <i.Col>
                            {destinations.length > 0 ?
                                <div>
                                    <h2>{Session.model.common.words.other_destinations}</h2>
                                    <c.CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                    <h2><i.NavLink style={{ color: "#FF5563", textDecoration: "none" }} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                </div>
                                : null
                            }
                        </i.Col>
                    </i.Row>

                </i.Container>
            </BasePage>
        );
    }
}

export default Tour;